import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/1.jpg';
const _withScopeId = n => (_pushScopeId("data-v-005e1cad"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "display": "block"
  },
  width: "100%",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注：若您不能确认地址是否在服务范围，请在兑换前致电40066—31115，联系客服热线核实确认后再进行兑换。", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
import commonMethod from '../common/common';
import { onMounted, ref, reactive, getCurrentInstance } from "vue";
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'serviceArea2',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    // 是否隐藏tab
    const hide_nav = ref(false);
    if (route.query && route.query.hide_nav == 1) {
      hide_nav.value = true;
    }
    const data = reactive({
      showArea: false,
      columns: []
    });
    onMounted(() => {
      proxy.$api.post(`${proxy.$url}Area/getServiceArea`, {
        st_id: 2
      }).then(res => {
        data.columns = res.data;
      }).catch(() => {
        commonMethod.toast('地址获取失败');
      });
    });
    // 返回上一页
    const back = () => {
      window.history.go(-1);
    };
    // 拨打电话
    const call = () => {
      window.location.href = 'tel:4006631115';
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!hide_nav.value ? (_openBlock(), _createBlock(_component_van_nav_bar, {
        key: 0,
        title: "家政可服务区域",
        "left-arrow": "",
        border: "",
        placeholder: "",
        onClickLeft: back
      })) : _createCommentVNode("", true), _createElementVNode("a", {
        target: "_blank",
        href: _ctx.$wxurl + '/H5/Activity/index'
      }, _hoisted_4, 8, _hoisted_2), _createVNode(_component_van_field, {
        "label-width": 200,
        readonly: "",
        clickable: "",
        name: "area2",
        label: "家政服务可服务区域",
        "right-icon": "arrow",
        onClick: _cache[0] || (_cache[0] = $event => data.showArea = true)
      }), _createVNode(_component_van_popup, {
        show: data.showArea,
        "onUpdate:show": _cache[1] || (_cache[1] = $event => data.showArea = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: data.columns,
          "confirm-button-text": " ",
          "cancel-button-text": " "
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createElementVNode("div", {
        class: "note"
      }, [_hoisted_5, _hoisted_6, _createElementVNode("span", {
        class: "serviceNo",
        onClick: call
      }, "服务热线：40066-31115")])]);
    };
  }
});